// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__7AbPU","latestInfoBox":"styles_latestInfoBox__BXMxb","updateContainer":"styles_updateContainer__rv+Q8"};